export default __webpack_public_path__ + "static/media/plus.13def8ad.svg";